module.exports = __webpack_public_path__ + "img/cat2.ca1ece84.png";